import "./es.object.assign-7e79fd7b.js";
import { c as d } from "./index-8b07dec9.js";
import h, { css as l } from "styled-components";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "react";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as u } from "./getMetrics-953aa4f8.js";
import { jsx as g } from "react/jsx-runtime";
import "./export-cdcbfb2b.js";
import "./object-keys-719a5561.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./function-apply-4756dee6.js";
import "./array-method-is-strict-e5a3c878.js";
var m = /* @__PURE__ */ function(i) {
  return i.HORIZONTAL = "horizontal", i.VERTICAL = "vertical", i;
}({}), $ = /* @__PURE__ */ function(i) {
  return i.Thin = "1px", i.Thick = "2px", i.Thicker = "3px", i;
}({}), z = /* @__PURE__ */ h.div.withConfig({
  displayName: "divider__StyledDivider",
  componentId: "sc-1vy8lu1-0"
})(["&.Divider{", ";", ";}"], function(i) {
  var r = i.$thickness, t = i.$size, o = i.$margin;
  return `
      margin: ` + o + `;
      &--horizontal {
        max-height: ` + r + `;
        height: ` + r + `;
        width: ` + t + `;
      },

      &--vertical {
        height: ` + t + `;
        width: ` + r + `;
      }
  `;
}, function(i) {
  var r = i.theme.components.divider;
  return l(r.Divider);
}), W = function(r) {
  var t = r.layout, o = t === void 0 ? m.HORIZONTAL : t, n = r.thickness, p = n === void 0 ? $.Thin : n, e = r.size, a = e === void 0 ? "100%" : e, s = r.margin, c = r.className, v = u({
    label: "Divider"
  });
  return /* @__PURE__ */ g(z, Object.assign({
    $thickness: p,
    $size: a,
    $margin: s,
    className: d("Divider", {
      "Divider--vertical": m.VERTICAL === o,
      "Divider--horizontal": m.HORIZONTAL === o
    }, c)
  }, v));
};
export {
  W as Divider,
  m as DividerLayout,
  $ as DividerThickness
};
